export default {
  'vehiclesHistory.list.header.customer': 'Customer',
  'vehiclesHistory.list.column.licensePlate': 'License Plate',
  'vehiclesHistory.list.column.vehicle': 'Vehicle',
  'vehiclesHistory.list.header.actions': 'Actions',
  'vehiclesHistory.list.action.button.view': 'To view',

  'vehiclesHistory.details.searchByDescription': 'Search by description',
  'vehiclesHistory.details.displayAuthorized': 'Display Authorized',

  'vehiclesHistory.details.list.column.description': 'Description',
  'vehiclesHistory.details.list.column.quantity': 'Quantity',
  'vehiclesHistory.details.list.column.unitaryValue': 'Unitary Value',
  'vehiclesHistory.details.list.column.discount': 'Discount',
  'vehiclesHistory.details.list.column.totalAmount': 'Total Amount',

  'vehiclesHistory.details.list.info.budget': 'Budget',
  'vehiclesHistory.details.list.info.customer': 'Customer: ',
  'vehiclesHistory.details.list.info.currentKilometers': 'Mile: ',
};
